// @libs
import PropTypes from "prop-types";
// @mui-material
import EditIcon from "@material-ui/icons/Edit";
//import EditIcon from "@mui/icons-material/Edit";

import { IconButton  as MuiIconButton, Tooltip } from "@material-ui/core";
// import { IconButton as MuiIconButton, Tooltip } from "@mui/material";


const EditIconButton = ({ title = "Editar", customIcon = null, onClick, ...props }) => {
  return (
    <Tooltip title={title}>
      <MuiIconButton
        onClick={onClick}
        aria-label={title}
        color="warning"
        size="small"
        sx={{
          transition: "transform 0.2s ease",
          "&:hover": {
            backgroundColor: "rgba(255, 193, 7, 0.1)",
            transform: "scale(1.1)",
          },
        }}
        {...props}
      >
        {customIcon || <EditIcon fontSize="small" />}
      </MuiIconButton>
    </Tooltip>
  );
};

EditIconButton.propTypes = {
  title: PropTypes.string,
  customIcon: PropTypes.node,
  onClick: PropTypes.func,
};

export default EditIconButton;
